import { Pagination, Table } from 'antd';
// import { ColumnTitle } from 'antd/lib/table/interface';
import classnames from 'classnames';
import React from 'react';

import './style.scss';

// type Column = {
//     title?: ColumnTitle<string>;
//     dataIndex?: string;
//     key?: string;
//     children?: any[];
//     render?: (record: any) => ReactNode;
// };

interface IProps {
    data: any[];
    columns: any[];
    bordered?: boolean;
    scroll?: any;
    rowTotalKeys?: string[];
    pagination?: boolean;
    currentPage?: number;
    total?: number;
    pageSize?: number;
    className?: string;
    loading?: boolean;
    rowKey?: any;
    pointer?: boolean;
    onChangePage?: (page: number, pageSize: number) => void;
    onRow?: (e: any) => void;
    summary?: any;
    rowSelection?: any;
    isScroll?: boolean;
    showSizeChanger?: boolean;
}

const TableAdmin: React.FC<IProps> = ({
    columns,
    data = [],
    bordered,
    scroll = { x: 'max-content' },
    isScroll = true,
    pagination,
    currentPage = 1,
    onChangePage,
    onRow,
    className,
    loading,
    rowKey,
    pointer,
    summary,
    rowSelection,
    total,
    pageSize = 20,
    showSizeChanger,
}) => {
    const onHandlePage = (page: number, pageSize: number) => {
        onChangePage && onChangePage(page, pageSize);
    };

    const scrollObj = {
        ...(isScroll && { scroll }),
    };

    return (
        <div className="table__wrap">
            <Table
                rowSelection={rowSelection}
                columns={columns}
                dataSource={data}
                bordered={bordered}
                pagination={false}
                loading={loading}
                className={classnames(className, { pointer: pointer === true })}
                rowKey={rowKey}
                summary={summary}
                {...scrollObj}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            onRow && onRow(record);
                        },
                    };
                }}
            />
            {pagination && data.length > 0 && (
                <Pagination
                    showSizeChanger={showSizeChanger}
                    onChange={onHandlePage}
                    current={+currentPage}
                    total={total}
                    // size="large"
                    showLessItems={false}
                    pageSize={pageSize}
                />
            )}
        </div>
    );
};

export default React.memo(TableAdmin);
